import React from 'react'
import styled from 'styled-components'
import { magicContainerStyle } from 'components/magic/styled'
import Image from '../../Image'

const Section = styled.section`
  position: relative;
  width: 100%;
`

const Container = styled.div`
  ${magicContainerStyle};
  text-align: center;
`

const ImageStyled = styled(Image)`
  width: 100%;
`

const ProductHeroSection = () => (
  <Section>
    <Container>
      <ImageStyled
        fileName="magic/ecosystem/ecosystem.png"
        alt="Flip ecosystem"
      />
    </Container>
  </Section>
)

export default ProductHeroSection
